import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/sites/$siteId/carriers')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['carriers:manage', 'carriers:access-read-only'])
    ) {
      throw redirect({ params: { siteId: params.siteId }, to: '/settings/sites/$siteId' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/carriers/pages/site-carriers-page')),
});
